import React from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import { capitalizeFirstLetters } from '../../common/strings';

export const DocumentHead = ({ selectedParkData, selectedScreen }) => {
    let title = 'Powerboard';

    title = `${
        selectedParkData.readableName ? selectedParkData.readableName : 'Powerboard'
    } | ${capitalizeFirstLetters(selectedScreen)}`;

    return (
        <Helmet>
            <title>{title}</title>
        </Helmet>
    );
};

DocumentHead.displayName = 'DocumentHead';
DocumentHead.propTypes = {
    selectedScreen: PropTypes.string,
    selectedParkData: PropTypes.object,
};
